import { useMutation } from '@tanstack/react-query'

import { ERewardHistoryStatus } from '../queries/use-get-list-reward-history-query'

import axiosInstance from '@/libs/configs/axios'

export enum EPayoutType {
  BANK = 'BANK',
  EWALLET = 'EWALLET',
}

export type TWithdrawPayload = {
  payoutId: string
  provider: string
  type: EPayoutType
}

export type TWithdrawResult = {
  success: boolean
  traceId: string
  error?: {
    code: string
    message: string
    errors: any[]
  }
  metadata: unknown
  result: {
    createdAt: string
    method: EPayoutType
    provider: string
    withdrawnAmount: number
    adminFee: number
    received: number
    payoutId: string
    status: ERewardHistoryStatus
    accountNumber: string
  }
}

async function postWithdrawAPI(
  { payoutId, provider, type }: TWithdrawPayload,
  useMockServer: boolean = false,
): Promise<TWithdrawResult> {
  try {
    const result = await axiosInstance({
      baseURL: useMockServer
        ? process.env.NEXT_PUBLIC_MOCK_API_URL
        : process.env.NEXT_PUBLIC_API_URL,
      url: `/reward/withdraw`,
      method: 'post',
      data: {
        payoutId,
        provider,
        type,
      },
    })

    return result?.data
  } catch (error: any) {
    throw error?.response?.data
  }
}

export default function usePostWithdrawMutation() {
  const { mutate, isSuccess, isPending, data, isError, error } = useMutation({
    mutationFn: ({ payoutId, provider, type }: TWithdrawPayload) =>
      postWithdrawAPI({
        payoutId,
        provider,
        type,
      }),
    onError: (err: TWithdrawResult) => {
      return err
    },
  })

  return {
    mutate,
    data,
    isSuccess,
    isPending,
    isError,
    error,
  }
}
